module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyCAMAAACd646MAAAARVBMVEUAKBQAbzgAej0AAAAACgUAUSkAcDgAKRQeMihts5D///////89DhPVMkTWMkURAQOKCxnOESbOESZFBg29ECMQAQOJCxlwGg4HAAAAE3RSTlP//////////+zG//7sxsX////+GfJ4pAAAAJtJREFUeAHtz7cVwzAQwFCJyTmH/Ud1hc7sDpUOC/yHZVmL3lJb95FaqzoDos6AqDMg6gyIOgMiz4AwMzxEnwGh3fARZmSEGRlhxkWYkRFmLIT2h7imSD2GdUokke0iiSSSyPkS1nWC3O6PuJ7/kdf7YSJsiAgbJsKGiLBhImyICBs28vkqBAgbJsKGiLBhImyoCBsqwoaKsGEiPwIHqRFDdN56AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kw.png
// module id = Zv28
// module chunks = 0